export var ConcurrencyControl;
(function (ConcurrencyControl) {
    // eslint-disable-next-line
    ConcurrencyControl[ConcurrencyControl["LAST_WRITE_WINS"] = 0] = "LAST_WRITE_WINS";
    // eslint-disable-next-line
    ConcurrencyControl[ConcurrencyControl["FAIL_ON_CONFLICT"] = 1] = "FAIL_ON_CONFLICT";
})(ConcurrencyControl || (ConcurrencyControl = {}));
//# sourceMappingURL=concurrency-control.js.map